let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2n614")).then(() => parcelRequire('pVRR4'));